import {isNotEmpty, isNotEmptyList} from "../utils/CommonUtil.ts";
import {Button, FormCheck, FormControl, FormLabel} from "react-bootstrap";
import {useEffect, useState} from "react";
import {_INIT_LIST_SEARCH_DATA, buildSearchUrl, calcChangedCondition} from "../utils/SearchUtil.ts";
import {useSearchParams, useNavigate} from "react-router-dom";
import {pressEnter} from "../utils/EventUtil.ts";

interface GoodsSearchProps {
    search: GoodsListSearchDto;
    closeMenu: () => void;
}
const GoodsSearch = ({
                         // @ts-ignore
                         search = {},
                         closeMenu = () => {}
}: GoodsSearchProps) => {
    const [keywords, setKeywords] = useState<string>("");

    const [goodsClass, setGoodsClass] = useState<CheckDto>();
    const [priceGroup, setPriceGroup] = useState<CheckDto>();
    const [giftBrands, setGiftBrands] = useState<CheckGroupDto[]>([]);

    // @ts-ignore
    // noinspection JSUnusedLocalSymbols
    const [searchParams, setSearchParams] = useSearchParams(_INIT_LIST_SEARCH_DATA);

    const navigate = useNavigate();
    // @ts-ignore
    const [largeClassMenu, setLargeClassMenu] = useState("");
    // @ts-ignore
    const [mediumClassMenu, setMediumClassMenu] = useState("");
    // @ts-ignore
    const [smallClassMenu, setSmallClassMenu] = useState("");

    // @ts-ignore
    // noinspection JSUnusedLocalSymbols
    const [selectedValue, setSelectedValue] = useState("");
    // @ts-ignore
    // noinspection JSUnusedLocalSymbols
    const [checkedPriceGroupValue, setCheckedPriceGroupValue] = useState<string[]>([]);
    // @ts-ignore
    // noinspection JSUnusedLocalSymbols
    const [checkedGiftBrandValue, setCheckedGiftBrandValue] = useState("");

    const handleChange = (event: any) => {
        setSelectedValue(event.target.value); // 状態の更新
    };

    const handlePriceGroupChange = (value: string) => {
        setCheckedPriceGroupValue((prev) =>
            prev.includes(value)
                ? prev.filter((item) => item !== value) // 解除
                : [...prev, value] // 追加
        );
    };
    const handleGiftBrandChange = (event: any) => {
        setCheckedGiftBrandValue(event.target.value); // 状態の更新
    };

    /**
     * 検索ボタンクリック
     */
    const handleSearch = () => {
        doSearchParameter();
        closeMenu();
    }

    const handleReset = () => {
        // キーワードのリセット
        setKeywords("");
        // 商品分類のリセット
        // noinspection DuplicatedCode
        if(goodsClass != null) {
            setGoodsClass(prevState => {
                if (prevState !== undefined) {
                    prevState.children.map((oldItem, index) => {
                        oldItem.checked = index == 0;
                    });
                }
                return prevState;
            });
            setSelectedValue("");
            setLargeClassMenu("");
            setMediumClassMenu("");
            setSmallClassMenu("");

        }

        // 価格グループのリセット
        // noinspection DuplicatedCode
        if(priceGroup != null) {
            setPriceGroup(prevState => {
                if (prevState !== undefined) {
                    prevState.children.map((oldItem) => {
                        oldItem.checked = false;
                    });
                }
                return prevState;
            });
            setCheckedPriceGroupValue([]);
        }

        // ギフトブランドのリセット
        if(giftBrands != null) {
            setGiftBrands(prevState => {
                if (prevState !== undefined) {
                    prevState.map((group) => {
                        group.checks.children.map((checkItem) => {
                            checkItem.checked = false;
                        });
                    });
                }
                return prevState;
            });
            setCheckedGiftBrandValue([])
        }
    }

    /**
     * 検索パラメータをURLにセットして再描画
     */
    const doSearchParameter = () => {
        // noinspection DuplicatedCode
        const priceGroupArray: string[] = [];
        if(priceGroup != null) {
            priceGroup.children.map(value => {
                if (value.checked) {
                    priceGroupArray.push(value.value);
                }
            });
        }
        const giftBrandArray: string[] = [];
        if(giftBrands != null) {
            giftBrands.map(group =>
                group.checks.children.map((checkItem) => {
                    if(checkItem.checked) {
                        giftBrandArray.push(checkItem.value)
                    }
                })
            );

        }
        const queryUrl = buildSearchUrl(searchParams, {
            page_index: "0",
            keywords: keywords,
            large_class: largeClassMenu,
            medium_class: mediumClassMenu,
            small_class: smallClassMenu,
            price_ranges: priceGroupArray,
            gift_brands: giftBrandArray,
            sub_site_section: search?.sub_site_section,

        });
        navigate(queryUrl);
    }

    /**
     * 変更した検索条件数をカウント
     */
    const calcCountSearchCondition = () => {
        return calcChangedCondition({
            keywords: keywords,
            large_class: largeClassMenu,
            medium_class: mediumClassMenu,
            small_class: smallClassMenu,
            price_ranges: checkedPriceGroupValue,
            gift_brands: checkedGiftBrandValue})
    }

    useEffect(() => {
        if(search != null) {
            setKeywords(search.keywords);
            setGoodsClass(search.goods_class);
            setPriceGroup(search.price_group);
            setGiftBrands(search.gift_brands);
        }
    }, [search]);

    // noinspection DuplicatedCode
    return (
      <>
          <form className={"search-form"}>
              <div className={"search-result"}>
                  {isNotEmpty(search?.total) &&
                    <>
                      検索結果：{search?.total}件
                    </>
                  }
              </div>
              {/*クリアボタン、検索ボタン*/}
              <div className={"search-section search-buttons"}>
                  <Button variant="light" className={"rounded-pill w-100 btn-clear"} onClick={handleReset}>条件をすべてクリア<span>（{calcCountSearchCondition()}）</span></Button>
                  <Button variant="primary" className={"rounded-pill w-100"} onClick={handleSearch}>
                      検 索<i className="fa-solid fa-magnifying-glass"></i>
                  </Button>
              </div>
              {/*検索キーワード*/}
              <div className={"search-section search-keywords"}>
                  <FormLabel htmlFor="keywords"
                             className={"search-label"}>商品名（商品コード）</FormLabel>
                  <FormControl type="text" id="keywords"
                               placeholder={"キーワード"}
                               value={keywords}
                               onChange={event => setKeywords(event.target.value)}
                               onKeyDown={(e) => {
                                   pressEnter(e, () => {
                                       handleSearch();
                                   })
                               }}
                  />
              </div>
              {/*商品分類（サイトマップの大分類）*/}
              {(goodsClass != null && isNotEmptyList(goodsClass.children)) &&
                <div className={"search-section goods-class"}>
                  <FormLabel className={"search-label border-b"}>商品分類</FormLabel>
                    {goodsClass.children.map((checkItem) =>
                        <FormCheck type="radio"
                                   label={checkItem.label}
                                   name={"goods-class"}
                                   id={"gc-" + checkItem.value}
                                   key={"gc-" + checkItem.value}
                                   checked={checkItem.checked}
                                   onChange={e => {
                                       const checked = e.target.checked;
                                       setGoodsClass(prevState => {
                                           if(prevState !== undefined) {
                                               prevState.children.map((oldItem) => {
                                                   if (oldItem.value == e.target.value) {
                                                       oldItem.checked = checked;
                                                       setLargeClassMenu(e.target.value);
                                                       setMediumClassMenu("");
                                                       setSmallClassMenu("");
                                                   } else {
                                                       oldItem.checked = !checked;
                                                   }
                                               });
                                           }
                                           return prevState;
                                       });
                                       handleChange(e);
                                   }}
                                   value={checkItem.value}/>
                    )}
                </div>
              }
              {/*価格帯（M_GOODSのOFFICIALPRICE）*/}
              {(priceGroup != null && isNotEmptyList(priceGroup.children)) &&
                <div className={"search-section"}>
                  <FormLabel className={"search-label border-b"}>価格帯</FormLabel>
                    {priceGroup.children.map((checkItem) =>
                        <FormCheck type="checkbox"
                                   label={checkItem.label}
                                   name={"pg-" + checkItem.value}
                                   id={"pg-" + checkItem.value}
                                   key={"pg-" + checkItem.value}
                                   checked={checkItem.checked}
                                   onChange={e => {
                                       const checked = e.target.checked;
                                       setPriceGroup(prevState => {
                                           if(prevState !== undefined) {
                                               prevState.children.map((oldItem) => {
                                                   if (oldItem.value == e.target.value) {
                                                       oldItem.checked = checked;
                                                   }
                                               });
                                           }
                                           return prevState;
                                       });
                                       handlePriceGroupChange(checkItem.value);
                                   }}
                                   value={checkItem.value}/>
                    )}
                </div>
              }
              {/*ギフトブランド（M_TAG + M_SITESECTION）*/}
              {isNotEmptyList(giftBrands) &&
                <div className={"search-section"}>
                  <FormLabel className={"search-label border-b"}>ギフトブランド</FormLabel>
                    {giftBrands.map(checkGroupItem =>
                        <div className={"brand-group"} key={checkGroupItem.group_name}>
                            <div className={"brand-group-title"}>{checkGroupItem.group_name}</div>
                            {(checkGroupItem.checks != null && isNotEmptyList(checkGroupItem.checks.children)) &&
                              <>
                                <div className={"brand-items"}>
                                    {checkGroupItem.checks.children.map((checkItem) =>
                                        <FormCheck type="checkbox"
                                                   label={checkItem.label}
                                                   name={"bg-" + checkItem.value}
                                                   id={"bg-" + checkItem.value}
                                                   key={"bg-" + checkItem.value}
                                                   checked={checkItem.checked}
                                                   onChange={e => {
                                                       // noinspection DuplicatedCode
                                                       const checked = e.target.checked;
                                                       setGiftBrands(prevState => {
                                                           if(prevState !== undefined) {
                                                               prevState.map(group =>
                                                                   group.checks.children.map((oldItem) => {
                                                                       if (oldItem.value == e.target.value) {
                                                                           oldItem.checked = checked;
                                                                       }
                                                                   })
                                                               );
                                                           }
                                                           return prevState;
                                                       });
                                                       handleGiftBrandChange(e);
                                                   }}
                                                   value={checkItem.value}/>
                                    )}
                                </div>
                              </>
                            }
                        </div>
                    )}
                </div>
              }
          </form>
      </>
    );
}
export default GoodsSearch;